export default [
  {
    name: 'Reusel-De Mierden',
    cities: [
      'Reusel'
    ]
  },
  {
    name: 'Rucphen',
    cities: [
      'Rucphen',
      'Sprundel',
      'St. Willebrord'
    ]
  },
  {
    name: 'Etten-Leur',
    cities: [
      'Etten-Leur'
    ]
  },
  {
    name: 'Oosterhout',
    cities: [
      'Oosterhout'
    ]
  },
  {
    name: 'Dongen',
    cities: [
      'Dongen'
    ]
  },
  {
    name: 'Gilze en Rijen',
    cities: [
      'Gilze',
      'Hulten',
      'Molenschot',
      'Rijen'
    ]
  },
  {
    name: 'Alphen-Chaam',
    cities: [
      'Alphen',
      'Chaam'
    ]
  },
  {
    name: 'Baarle',
    cities: [
      'Baarle-Nassau'
    ]
  },
  {
    name: 'Boxtel',
    cities: [
      'Boxtel'
    ]
  },
  {
    name: 'Breda',
    cities: [
      'Breda',
      'Bavel',
      'Prinsenbeek',
      'Ulvenhout'
    ]
  },
  {
    name: 'Zundert',
    cities: [
      'Rijsbergen',
      'Zundert'
    ]
  },
  {
    name: 'Goirle',
    cities: [
      'Goirle'
    ]
  },
  {
    name: 'Tilburg',
    cities: [
      'Berkel-Enschot',
      'Tilburg',
      'Udenhout'
    ]
  },
  {
    name: 'Oisterwijk',
    cities: [
      'Moergestel',
      'Oisterwijk'
    ]
  },
  {
    name: 'Hilvarenbeek',
    cities: [
      'Hilvarenbeek',
      'Biest-Houtakker',
      'Diessen',
      'Esbeek',
      'Haghorst'
    ]
  },
  {
    name: 'Loon op Zand | Kaatsheuvel',
    cities: [
      'Kaatsheuvel',
      'Loon Op Zand'
    ]
  },
  {
    name: 'Bladel',
    cities: [
      'Bladel',
      'Hapert'
    ]
  },
  {
    name: 'Moerdijk',
    cities: [
      'Fijnaart',
      'Zevenbergen'
    ]
  },
  {
    name: 'Bergeijk',
    cities: [
      'Bergeijk'
    ]
  },
  {
    name: 'Drimmelen',
    cities: [
      'Drimmelen'
    ]
  },
  {
    name: 'Eersel',
    cities: [
      'Eersel'
    ]
  },
  {
    name: 'Vught',
    cities: [
      'Vught'
    ]
  },
  {
    name: 'Oirschot',
    cities: [
      'Oirschot'
    ]
  },
  {
    name: 'Maasdriel',
    cities: [
      'Kerkdriel',
      'Ammerzoden',
      'Hedel',
      'Rossum'
    ]
  }
]